import React from 'react'
import Link from 'gatsby-link'
import MovingSquares from '../components/moving-squares'

const IndexPage = () => (
	<div className="container-fluid">
		<form name="contact" method="POST" netlify className="contact-form">
		  <p>
		    <label>Your Name: <input type="text" name="name" /></label>   
		  </p>
		  <p>
		    <label>Your Email: <input type="email" name="email" /></label>
		  </p>
		  <p>
		    <label>Message: <textarea name="message"></textarea></label>
		  </p>
		  <p>
		    <button type="submit">Send</button>
		  </p>
		</form>
	</div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/contact.js